import { render, staticRenderFns } from "./extensionGoods.vue?vue&type=template&id=29288593"
import script from "./extensionGoods.vue?vue&type=script&lang=js"
export * from "./extensionGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports